import React, { useLayoutEffect } from "react";
import { useMessageListContext } from "stream-chat-react";
import { observeMessageListSize } from "./observeMessageListSize";

export const StableMessageListPanel = ({ children }) => {
  const { listElement, scrollToBottom } = useMessageListContext();
  useLayoutEffect(
    () => observeMessageListSize(listElement, scrollToBottom),
    [listElement, scrollToBottom]
  );
  // Keep Stream's panel layout and use its scroll helper so message-search
  // and suppressed-autoscroll views retain their existing behavior.
  return (
    <div className="str-chat__main-panel-inner str-chat__message-list-main-panel">
      {children}
    </div>
  );
};
